import React, { useContext } from "react";
import { Fade } from "react-awesome-reveal";
import { Mail, MapPin, Clock, CalendarDays } from "lucide-react";
import bg from "../../assets/bgblue.webp";
import Form from "../../components/ContactForm";
import HeroSmall from "../../components/HeroSmall";
import SEO from "../../utils/SEO";
import { LanguageContext } from "../../context/LanguageContext";
import no from "../../context/no";
import en from "../../context/en";

function Book() {
  const { language } = useContext(LanguageContext);
  const text = language === "no" ? no.bookAppointment : en.bookAppointment;
  const buttons = language === "no" ? no.home.button : en.home.button;

  const place = "Steinkjellergaten+2+5003+Bergen";

  return (
    <>
      <SEO title={text.title} description={text.tellUs} />
      <main className="overflow-hidden">
        <HeroSmall bg={bg} title={text.title} subtitle={text.tellUs} />

        <section className="pb-16 pt-10 md:pb-24 md:pt-14">
          <div className="container">
            <div className="wrap">
              <div className="mx-auto grid max-w-6xl grid-cols-1 gap-12 md:grid-cols-2 md:gap-16 lg:gap-20">
                {/* Info column */}
                <Fade direction="up" triggerOnce>
                  <div className="flex flex-col gap-10">
                    <div>
                      <h2 className="mb-3 font-heading text-2xl font-bold text-main-dark md:text-3xl">
                        {text.dropIn}
                      </h2>
                      <p className="max-w-md font-copy leading-relaxed text-main-dark/75">
                        {text.description}
                      </p>
                    </div>

                    <ul className="flex flex-col gap-6">
                      <li className="flex gap-4">
                        <Mail
                          className="mt-0.5 h-5 w-5 shrink-0 text-main-dark"
                          color="#000000"
                          strokeWidth={1.5}
                          aria-hidden="true"
                        />
                        <div>
                          <p className="mb-1 font-heading text-xs font-bold uppercase tracking-wider text-main-dark/50">
                            {text.form.email}
                          </p>
                          <a
                            href="mailto:post@instantiris.no"
                            className="font-copy text-main-dark transition-opacity hover:opacity-70"
                          >
                            post@instantiris.no
                          </a>
                        </div>
                      </li>

                      <li className="flex gap-4">
                        <MapPin
                          className="mt-0.5 h-5 w-5 shrink-0 text-main-dark"
                          color="#000000"
                          strokeWidth={1.5}
                          aria-hidden="true"
                        />
                        <div>
                          <p className="mb-1 font-heading text-xs font-bold uppercase tracking-wider text-main-dark/50">
                            {text.location.title}
                          </p>
                          <p className="font-copy text-main-dark">
                            {text.location.address}
                          </p>
                          <button
                            type="button"
                            className="mt-2 font-copy text-sm text-iris-brown underline-offset-2 hover:underline"
                            onClick={() =>
                              window.open(
                                `https://www.google.com/maps/search/?api=1&query=${place}`
                              )
                            }
                          >
                            {buttons.openMap}
                          </button>
                        </div>
                      </li>

                      <li className="flex gap-4">
                        <Clock
                          className="mt-0.5 h-5 w-5 shrink-0 text-main-dark"
                          color="#000000"
                          strokeWidth={1.5}
                          aria-hidden="true"
                        />
                        <div>
                          <p className="mb-1 font-heading text-xs font-bold uppercase tracking-wider text-main-dark/50">
                            {text.openingHours.title}
                          </p>
                          <p className="font-copy text-main-dark">
                            {text.openingHours.wednesday}
                          </p>
                          <p className="font-copy text-main-dark">
                            {text.openingHours.thursday}
                          </p>
                          <p className="font-copy text-main-dark">
                            {text.openingHours.saturday}
                          </p>
                          <p className="mt-2 font-copy text-sm text-main-dark/60">
                            {text.openingHours.note}
                          </p>
                        </div>
                      </li>
                    </ul>

                    <div className="self-start">
                      <a
                        href="https://instantiris.onlinebooq.net/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="cta gradient !inline-flex w-fit items-center justify-center gap-2 whitespace-nowrap"
                      >
                        <CalendarDays
                          className="h-5 w-5"
                          color="#f3f3f3"
                          strokeWidth={1.5}
                          aria-hidden="true"
                        />
                        {buttons.book}
                      </a>
                    </div>
                  </div>
                </Fade>

                {/* Form column */}
                <Fade direction="up" delay={100} triggerOnce>
                  <div className="bg-white p-6 shadow-iris md:p-8">
                    <h2 className="mb-2 font-heading text-xl font-bold text-main-dark md:text-2xl">
                      {text.form.book}
                    </h2>
                    <p className="mb-6 font-copy text-sm text-main-dark/60">
                      {text.form.intro}
                    </p>
                    <Form />
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Book;
